export const categories = [
  {
    id: "korean",
    name: "韩漫",
    slug: "korean",
    icon: "ri-global-line",
    description: "韩国漫画以其精致的画风和独特的叙事风格著称，涵盖恋爱、奇幻、悬疑等多种题材，条漫形式带来流畅的阅读体验。",
  },
  {
    id: "japanese",
    name: "日漫",
    slug: "japanese",
    icon: "ri-global-line",
    description: "日本漫画拥有深厚的文化底蕴，从少年热血到少女恋爱，从科幻冒险到日常治愈，丰富多元的题材满足各类读者需求。",
  },
  {
    id: "chinese",
    name: "国漫",
    slug: "chinese",
    icon: "ri-global-line",
    description: "国产漫画近年来蓬勃发展，融合中国传统文化元素与现代审美，涌现出大量优秀作品，画风精美、故事引人入胜。",
  },
];

export const mangas = [
  {
    id: "1",
    title: "星辰变",
    author: "我吃西红柿",
    category: "chinese",
    categoryName: "国漫",
    tags: ["玄幻", "修仙", "热血"],
    rating: 9.2,
    views: 12500000,
    chapters: 486,
    status: "连载中",
    updatedAt: "2026-08-03",
    cover: "https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20cover%20style%20illustration%20of%20a%20young%20cultivator%20in%20flowing%20robes%20standing%20on%20a%20mountain%20peak%20under%20a%20starry%20sky%2C%20sword%20in%20hand%2C%20ethereal%20energy%20swirling%20around%2C%20dramatic%20lighting%2C%20vibrant%20colors%2C%20manga%20art%20style%2C%20clean%20composition%2C%20soft%20cherry%20blossom%20petals%20floating&width=600&height=800&seq=manga-cover-01&orientation=portrait",
    description: "一颗流星坠入凡间，一个少年踏上修仙之路。星辰之力孕育无限可能，修仙世界的奥秘等待探索。秦羽从小便展现出非凡的天赋，然而命运却给他设下了重重考验...",
  },
  {
    id: "2",
    title: "霸道总裁的契约新娘",
    author: "糖果工作室",
    category: "korean",
    categoryName: "韩漫",
    tags: ["恋爱", "都市", "总裁"],
    rating: 8.8,
    views: 9800000,
    chapters: 312,
    status: "连载中",
    updatedAt: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20romance%20cover%2C%20elegant%20woman%20in%20a%20stunning%20evening%20dress%20with%20a%20handsome%2C%20cold%20CEO%20type%20man%20in%20a%20tailored%20suit%2C%20soft%20romantic%20lighting%2C%20rose%20petals%2C%20clean%20modern%20aesthetic%2C%20pastel%20tones%2C%20webtoon%20art%20style&width=600&height=800&seq=manga-cover-02&orientation=portrait",
    description: "为了拯救家族企业，她被迫与冷血总裁签订契约婚姻。原以为只是一场交易，却没想到他逐渐展现出温柔的一面。当真心遇上契约，爱情能否战胜一切阻碍？",
  },
  {
    id: "3",
    title: "鬼灭之剑",
    author: "吾峠呼世晴",
    category: "japanese",
    categoryName: "日漫",
    tags: ["热血", "战斗", "冒险"],
    rating: 9.5,
    views: 25000000,
    chapters: 205,
    status: "已完结",
    updatedAt: "2026-07-28",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20cover%20style%2C%20young%20warrior%20with%20a%20katana%20in%20a%20dynamic%20action%20pose%2C%20intense%20expression%2C%20flame%20effects%20surrounding%20him%2C%20dark%20night%20background%20with%20dramatic%20lighting%2C%20vibrant%20fire%20colors%2C%20manga%20illustration%2C%20clean%20bold%20lines&width=600&height=800&seq=manga-cover-03&orientation=portrait",
    description: "在恶鬼横行的时代，少年剑士踏上了斩杀鬼王的征途。为守护所爱之人，他握紧手中的剑，与伙伴们一同书写传奇。血与火的战斗，从未停止。",
  },
  {
    id: "4",
    title: "斗罗世界",
    author: "唐家三少",
    category: "chinese",
    categoryName: "国漫",
    tags: ["玄幻", "冒险", "热血"],
    rating: 9.4,
    views: 32000000,
    chapters: 520,
    status: "连载中",
    updatedAt: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20cover%20illustration%20of%20a%20young%20warrior%20with%20glowing%20martial%20spirit%20energy%2C%20dynamic%20combat%20pose%2C%20mythical%20creatures%20in%20background%2C%20golden%20and%20crimson%20color%20palette%2C%20dramatic%20composition%2C%20Chinese%20fantasy%20art%20style&width=600&height=800&seq=manga-cover-04&orientation=portrait",
    description: "唐门外门弟子唐三，因偷学内门绝学被追捕，以死明志后穿越到斗罗大陆。在这里，每个人都拥有自己的武魂，通过修炼成为强大的魂师。",
  },
  {
    id: "5",
    title: "她的秘密花园",
    author: "MINA",
    category: "korean",
    categoryName: "韩漫",
    tags: ["恋爱", "校园", "治愈"],
    rating: 9.0,
    views: 7500000,
    chapters: 168,
    status: "已完结",
    updatedAt: "2026-07-15",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20sweet%20high%20school%20girl%20with%20long%20hair%20in%20a%20garden%20full%20of%20flowers%2C%20soft%20sunlight%2C%20gentle%20color%20palette%20of%20pinks%20and%20greens%2C%20dreamy%20atmosphere%2C%20clean%20webtoon%20illustration%20style&width=600&height=800&seq=manga-cover-05&orientation=portrait",
    description: "平凡的女高中生偶然发现了一个神秘花园，在那里她遇见了改变她一生的人。青春的秘密、懵懂的恋情，都在这个秘密花园中悄然绽放。",
  },
  {
    id: "6",
    title: "一拳超人",
    author: "ONE",
    category: "japanese",
    categoryName: "日漫",
    tags: ["搞笑", "战斗", "英雄"],
    rating: 9.3,
    views: 18000000,
    chapters: 240,
    status: "连载中",
    updatedAt: "2026-08-02",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20action%20comedy%20manga%20cover%2C%20bald%20superhero%20with%20a%20yellow%20jumpsuit%20and%20red%20cape%2C%20simple%20expression%20but%20powerful%20aura%2C%20explosive%20action%20background%2C%20bold%20lines%2C%20dynamic%20composition%2C%20manga%20art%20style&width=600&height=800&seq=manga-cover-06&orientation=portrait",
    description: "埼玉原本是一个普通的上班族，通过三年的拼命锻炼获得了无敌的力量——只需一拳就能击败任何敌人。然而，强大的力量也带来了无尽的空虚...",
  },
  {
    id: "7",
    title: "全职法师",
    author: "乱",
    category: "chinese",
    categoryName: "国漫",
    tags: ["魔法", "校园", "热血"],
    rating: 9.1,
    views: 15000000,
    chapters: 890,
    status: "连载中",
    updatedAt: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20magic%20school%20cover%2C%20young%20male%20mage%20casting%20powerful%20elemental%20spells%2C%20lightning%20and%20fire%20magic%20effects%2C%20magic%20academy%20in%20background%2C%20vibrant%20colors%2C%20dynamic%20pose%2C%20Chinese%20manga%20style&width=600&height=800&seq=manga-cover-07&orientation=portrait",
    description: "莫凡获得了双系魔法天赋，进入明珠学府魔法学院。在这个魔法至上的世界，他凭借自己的努力和智慧，一步步走向法神的巅峰。",
  },
  {
    id: "8",
    title: "被诅咒的公主",
    author: "LEE HYE",
    category: "korean",
    categoryName: "韩漫",
    tags: ["奇幻", "恋爱", "宫廷"],
    rating: 9.2,
    views: 11200000,
    chapters: 198,
    status: "连载中",
    updatedAt: "2026-08-03",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%2C%20beautiful%20princess%20in%20an%20elegant%20gown%20with%20a%20mysterious%20curse%20mark%2C%20dark%20castle%20interior%2C%20magical%20glowing%20elements%2C%20dramatic%20contrast%20lighting%2C%20romantic%20fantasy%20aesthetic%2C%20clean%20webtoon%20art&width=600&height=800&seq=manga-cover-08&orientation=portrait",
    description: "从小被诅咒缠身的公主，被告知在二十岁生日那天将会死去。为了打破诅咒，她踏上了寻找解除之法的旅程，却意外揭开了王室深藏的秘密。",
  },
  {
    id: "9",
    title: "进击的巨人",
    author: "谏山创",
    category: "japanese",
    categoryName: "日漫",
    tags: ["战斗", "悬疑", "生存"],
    rating: 9.6,
    views: 35000000,
    chapters: 139,
    status: "已完结",
    updatedAt: "2026-06-20",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%2C%20soldiers%20facing%20a%20massive%20titan%20in%20a%20dynamic%20battle%20scene%2C%20walls%20and%20destruction%20background%2C%20intense%20dramatic%20composition%2C%20dark%20moody%20colors%2C%20detailed%20manga%20art%20style&width=600&height=800&seq=manga-cover-09&orientation=portrait",
    description: "人类被巨人逼到了灭绝的边缘，只能躲在高墙之后苟延残喘。少年艾伦目睹母亲被巨人吞噬，誓要将所有巨人驱逐殆尽。自由之翼，终将翱翔。",
  },
  {
    id: "10",
    title: "完美世界",
    author: "辰东",
    category: "chinese",
    categoryName: "国漫",
    tags: ["玄幻", "仙侠", "热血"],
    rating: 9.3,
    views: 20000000,
    chapters: 650,
    status: "连载中",
    updatedAt: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%2C%20powerful%20immortal%20cultivator%20floating%20above%20clouds%20with%20a%20heavenly%20palace%20in%20background%2C%20golden%20divine%20light%2C%20flowing%20robes%2C%20epic%20scale%2C%20ethereal%20atmosphere%2C%20Chinese%20fantasy%20illustration&width=600&height=800&seq=manga-cover-10&orientation=portrait",
    description: "一粒尘可填海，一株草斩日月星辰。一个少年从大荒中走出，一切从这里开始。石昊，一个被视为不祥之人的孩子，将在乱世中崛起。",
  },
  {
    id: "11",
    title: "恋爱革命",
    author: "232",
    category: "korean",
    categoryName: "韩漫",
    tags: ["恋爱", "校园", "喜剧"],
    rating: 8.9,
    views: 8600000,
    chapters: 230,
    status: "已完结",
    updatedAt: "2026-05-30",
    cover: "https://readdy.ai/api/search-image?query=Korean%20school%20romance%20webtoon%20cover%2C%20cute%20high%20school%20couple%20in%20school%20uniforms%20sharing%20a%20sweet%20moment%2C%20cherry%20blossom%20trees%20in%20spring%2C%20warm%20sunlight%2C%20soft%20pastel%20colors%2C%20youthful%20romantic%20atmosphere%2C%20webtoon%20style&width=600&height=800&seq=manga-cover-11&orientation=portrait",
    description: "公主英是一个单纯的高中男生，他对同班同学子琳一见钟情。为了追求心爱的女孩，他展开了一场轰轰烈烈的恋爱革命。笑中带泪的青春故事。",
  },
  {
    id: "12",
    title: "咒术回战",
    author: "芥见下下",
    category: "japanese",
    categoryName: "日漫",
    tags: ["战斗", "奇幻", "校园"],
    rating: 9.4,
    views: 22000000,
    chapters: 270,
    status: "连载中",
    updatedAt: "2026-08-03",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20supernatural%20manga%20cover%2C%20young%20sorcerer%20with%20dark%20spiky%20hair%20surrounded%20by%20cursed%20energy%20effects%2C%20dynamic%20fighting%20pose%2C%20urban%20Tokyo%20background%2C%20vibrant%20blue%20and%20purple%20energy%2C%20manga%20illustration%20style&width=600&height=800&seq=manga-cover-12&orientation=portrait",
    description: "虎杖悠仁吞下了诅咒之王的手指，成为了两面宿傩的容器。为了收集剩下的手指，他加入了东京都立咒术高等专门学校，踏上了与诅咒战斗的道路。",
  },
];

export const slides = [
  {
    id: "slide-1",
    mangaId: "4",
    title: "斗罗世界",
    subtitle: "唐家三少巅峰之作 · 全网点击破3200万",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20manhua%20banner%2C%20young%20warrior%20with%20glowing%20martial%20spirit%20battle%20scene%2C%20mythical%20dragon%20and%20phoenix%20in%20background%2C%20golden%20divine%20light%2C%20dramatic%20cinematic%20composition%2C%20cherry%20blossom%20petals%2C%20epic%20atmosphere&width=1600&height=700&seq=manga-slide-01&orientation=landscape",
  },
  {
    id: "slide-2",
    mangaId: "9",
    title: "进击的巨人",
    subtitle: "现象级神作 · 全网点击破3500万",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20banner%2C%20colossal%20titan%20breaking%20through%20massive%20walls%2C%20soldiers%20with%20ODM%20gear%20flying%20through%20air%2C%20epic%20battle%20scene%2C%20dramatic%20cinematic%20composition%2C%20cherry%20blossom%20petals%20contrast&width=1600&height=700&seq=manga-slide-02&orientation=landscape",
  },
  {
    id: "slide-3",
    mangaId: "3",
    title: "鬼灭之剑",
    subtitle: "世代传承的意志 · 全网点击破2500万",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20action%20manga%20banner%2C%20young%20swordsman%20with%20flame%20breathing%20technique%2C%20beautiful%20water%20and%20fire%20effects%2C%20night%20sky%20with%20stars%2C%20cherry%20blossom%20petals%20floating%2C%20cinematic%20composition%2C%20vibrant%20colors&width=1600&height=700&seq=manga-slide-03&orientation=landscape",
  },
];